module.exports = __webpack_public_path__ + "img/chapter-2-thumb.30f66882.jpg";